import {
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    Typography,
    Button,
    CardMedia,
  } from "@material-ui/core";
  import CasoWAF from "../../../assets/images/casos_de_exito/Ciberseguridad_caja_arequipa.jpg";
  import React from "react";
  import {Link} from "react-router-dom";
  
  export const CardCasoWAF = (props) => {
    return (
      <Card
        style={{
          backgroundColor: "#232F3E",
          margin: "auto",
          minWidth: "200px",
          maxWidth: "300px",
        }}
      >
        <CardActionArea>
          <CardMedia
            style={{ height: "180px" }}
            image={CasoWAF}
            title="Caso SDP WAF"
          />
          <CardContent>
            <Typography
              variant="body2"
              color="textSecondary"
              component="p"
              style={{fontDisplay:"auto", color: "white" }}
            >
              Protege tu servicio web Wordpress mediante AWS WAF, enfrentando amenazas como SQLi, DDoS y bots maliciosos.
              <br />
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions
          style={{
            maxHeight: "40px",
            alignItems: "flex-end",
            justifyContent: "center",
          }}
        >
          <Link
            to="/aws/casos-exito/caso-waf"
            style={{
              backgroundColor: "var(--rojo)",
              color: "white",
              padding: "4px 8px",
              borderRadius: "2px",
            }}
            size="small"
            color="primary"
          >
            <Button
            style={{
              backgroundColor: "var(--rojo)",
              color: "white",
              padding: "4px 8px",
              borderRadius: "2px",
            }}
            >
              Ver Más
            </Button>
          </Link>
          
        </CardActions>
      </Card>
    );
  };
  